import { gatherRules } from "../";
import { i18n } from "@/services/vue-i18n";

export default {
  role: gatherRules("app.required").concat([
    v =>
      !v ||
      v === i18n.t("user.roles.student.title") ||
      v === i18n.t("user.roles.teacher.title") ||
      i18n.t("validation.user.role")
  ]),
  age: gatherRules("app.numbers.strictPositive").concat([
    v => !v || v <= 16 || i18n.t("validation.user.not-child")
  ]),
  name: gatherRules(
    "app.required",
    "app.text.min",
    "app.text.small",
    "app.numbers.none",
    "app.specials.none"
  ),
  phone1: gatherRules("app.required", "app.numbers.isOne").concat([
    v =>
      !v || v.length >= 10 || i18n.tc("validation.general.text.custom.min", 10)
  ]),
  phone2: gatherRules("app.numbers.isOne").concat([
    v =>
      !v || v.length >= 10 || i18n.tc("validation.general.text.custom.min", 10)
  ]),
  email: gatherRules("app.required").concat([
    v => /.+@.+/.test(v) || i18n.t("validation.user.email")
  ]),
  password: gatherRules("app.required", "app.text.small"),
  newPassword: gatherRules("app.required", "app.text.small").concat([
    v => !v || v.length >= 8 || i18n.tc("validation.general.text.custom.min", 8)
  ])
};
